import React from 'react'
import { useCookies } from 'react-cookie'
import classNames from 'classnames'
import { Button } from '../../Button/Button'
import './PluginPromo.scss'

export const PROMO_COOKIE_MAX_AGE = 60 * 60 * 24 * 365

export enum PromoType {
  OUTLOOK_MAIL = 'OUTLOOK_MAIL',
  OUTLOOK_CALENDAR = 'OUTLOOK_CALENDAR',
  ZOOM = 'ZOOM',
}

const PROMO_COOKIE_CONFIG: { [key in PromoType]: { cookieName: string; maxAge?: number } } = {
  [PromoType.OUTLOOK_MAIL]: {
    cookieName: 'hideOutlookMailPromo',
  },
  [PromoType.OUTLOOK_CALENDAR]: {
    cookieName: 'hideOutlookCalendarPromo',
  },
  [PromoType.ZOOM]: {
    cookieName: 'hideZoomPromo',
  },
}

interface PluginPromoProps {
  containerClassname?: string
  Icon: React.ReactNode
  InstallButton: React.ReactNode
  header: string
  body: string
  promoType: PromoType
}

export const PluginPromo: React.FC<PluginPromoProps> = ({ Icon, InstallButton, header, body, promoType, containerClassname }) => {
  const [cookies, setCookie] = useCookies()

  const { cookieName, maxAge = PROMO_COOKIE_MAX_AGE } = PROMO_COOKIE_CONFIG[promoType]

  if (cookies[cookieName]) {
    return null
  }

  const handleHide = () => setCookie(cookieName, true, { path: '/', maxAge })

  return (
    <div className={classNames(containerClassname, 'd-flex flex-column p-4 gap-3 zocks-border-0.5 position-relative')}>
      <div className='d-flex gap-3 align-items-center'>
        {Icon}
        <h6 className='zocks-text-white'>{header}</h6>
      </div>
      <div className='paragraph-medium zocks-text-white'>{body}</div>
      <div className='d-flex'>{InstallButton}</div>
      <Button className='p-0 position-absolute zocks-text-white promo-hide-button' onClick={handleHide}>
        <i className='bi bi-x fs-3 fw-lighter' />
      </Button>
    </div>
  )
}
